import { api } from './api';

export interface FinancialPolicy {
  vatRate: number;
  commissionPct: number;
  billingApprovalRequired: boolean;
  writeOffApprovalThreshold: number | null;
}

export async function fetchFinancialPolicy(): Promise<FinancialPolicy> {
  return (await api.get('/financial-policy')).data.data as FinancialPolicy;
}

export async function updateFinancialPolicy(input: Partial<FinancialPolicy>): Promise<FinancialPolicy> {
  return (await api.put('/financial-policy', input)).data.data as FinancialPolicy;
}
